// Port of api/fuel/app/classes/insights/collection/durations.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'durations',
    insight: ['duration'],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_collection()) return {}

        var index = (vars && vars.index !== undefined) ? vars.index : 0

        var durationType = (filter.duration !== undefined) ? filter.duration : 'range'

        if (detail) {

            var where = ''

            if (index === false) index = 0

            if (durationType === 'range') {
                where = 'CAST(g.game_time_min / 10 AS INTEGER) <= ' + index + ' AND CAST(g.game_time_max / 10 AS INTEGER) >= ' + index
            } else if (durationType === 'min') {
                where = 'CAST(g.game_time_min / 10 AS INTEGER) = ' + index
            } else if (durationType === 'max') {
                where = 'CAST(g.game_time_max / 10 AS INTEGER) = ' + index
            } else if (durationType === 'mid') {
                where = 'CAST((((g.game_time_max - g.game_time_min) / 2) + g.game_time_min) / 10 AS INTEGER) ' + ((index == 35) ? '>' : '') + '= ' + index
            }

            var raw = Util.queryFast('\
                SELECT \
                    g.game_id AS g, \
                    g.game_time_max AS x, \
                    g.game_time_min AS n \
                FROM \
                    collection c \
                    JOIN \
                    game g \
                    ON \
                    c.game_id = g.game_id \
                WHERE \
                    c.user_id IN (' + Util.in(userIndex) + ') \
                    AND \
                    c.collection_own = 1 \
                    AND \
                    c.collection_expansion = 0 \
                    AND \
                    g.game_time_min > 0 \
                    AND \
                    g.game_time_max > 0 \
                    AND \
                    ' + where + ' \
                GROUP BY \
                    g.game_id \
                ORDER BY \
                    g.game_sortname ASC \
            ')

            var games = []

            for (var ri = 0; ri < raw.length; ri++) {
                this._references.games.push(parseInt(raw[ri].g, 10))

                games.push({
                    id: parseInt(raw[ri].g, 10),
                    min: parseInt(raw[ri].n, 10),
                    max: parseInt(raw[ri].x, 10)
                })
            }

            return {
                games: games
            }

        } else {

            var durations = []

            for (var di = 0; di < 360; di += 10) {
                durations.push(0)
            }

            var rawAll = Util.queryFast('\
                SELECT \
                    g.game_time_min as n, \
                    g.game_time_max as x \
                FROM \
                    collection c \
                    JOIN \
                    game g \
                    ON \
                    c.game_id = g.game_id \
                WHERE \
                    c.user_id IN (' + Util.in(userIndex) + ') \
                    AND \
                    c.collection_own = 1 \
                    AND \
                    c.collection_expansion = 0 \
                GROUP BY \
                    g.game_id \
            ')

            for (var ai = 0; ai < rawAll.length; ai++) {
                var aitem = rawAll[ai]

                if (aitem.n && aitem.x) {

                    var min = Math.floor(aitem.n / 10)
                    var max = Math.floor(aitem.x / 10)

                    if (min > 35) min = 35
                    if (max > 35) max = 35

                    if (durationType === 'range') {

                        for (var j = min; j <= max; j++) {
                            durations[j]++
                        }

                    } else if (durationType === 'min') {

                        durations[min]++

                    } else if (durationType === 'max') {

                        durations[max]++

                    } else if (durationType === 'mid') {

                        var mid
                        if (aitem.n != aitem.x) {
                            mid = ((aitem.x - aitem.n) / 2) + aitem.n
                        } else {
                            mid = aitem.n
                        }

                        mid = Math.floor(mid / 10)
                        if (mid > 35) mid = 35

                        durations[mid]++

                    }

                }
            }

            return {
                durations: durations
            }

        }

    }
})
